<div>
  <h1 class="f3 f2-ns ma4 mb6">Page Not Found</h1>
</div>